import React from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import logo from "./savationChristLogo.png";
import api from "../../api/api";

const GradesDistributionPdf = ({
  pdfGradeClass,
  pdfSubject,
  pdfPeriod,
  selectedYear,
  token,
  setAlertMessage,
  setAlertSeverity,
  setSnackbarOpen
}) => {


const fetchPdfGrades = async () => {
  if (!pdfGradeClass || !pdfSubject || !pdfPeriod) return [];

  try {
    const res = await api.get("/api/users/grades-distribution/", {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        academic_year: selectedYear?.id,
        grade_class: pdfGradeClass.id,
        subject: pdfSubject.id,
        period: pdfPeriod.id,
        page_size: 5000,
      },
    });


return (res.data.results || []).filter(
  r =>
    r.grade_class_name === pdfGradeClass.name &&
    r.subject_name === pdfSubject.name &&
    r.period_name === pdfPeriod.name
);

  } catch (err) {
    console.error("FILTER ERROR:", err.response?.data || err);
    return [];
  }
};



const handleDownloadPdf = async () => {

  if (!pdfGradeClass || !pdfPeriod || !pdfSubject) {
    setAlertMessage("Please select Grade, Subject, and Period");
    setAlertSeverity("error");
    setSnackbarOpen(true);
    return;
  }


  let filteredRows = await fetchPdfGrades();


  if (!filteredRows.length) {
    setAlertMessage("No grades found for this selection");
    setAlertSeverity("error");
    setSnackbarOpen(true);
    return;
  }


  const gradeClassName = pdfGradeClass.name;
  const subjectName = pdfSubject.name;
  const periodName = pdfPeriod.name;


  const groupedByStudent = filteredRows.reduce((acc,row)=>{
    if(!acc[row.student_name]){
      acc[row.student_name]={
        student_name:row.student_name,
        subject:row
      };
    }
    return acc;
  },{});


  const studentsArray = Object.values(groupedByStudent);


  const rowsPerPagePdf = 25;
  const totalPages = Math.ceil(studentsArray.length / rowsPerPagePdf);


  const pdf = new jsPDF("p","mm","a4");

  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();



  const logoImg = new Image();
  logoImg.src = logo;
  logoImg.crossOrigin="anonymous";

  await new Promise(resolve=>{
    logoImg.onload=resolve;
  });



for(let page=0; page<totalPages; page++){


const pageStudents = studentsArray.slice(
 page*rowsPerPagePdf,
 (page+1)*rowsPerPagePdf
);



const pdfContainer=document.createElement("div");

pdfContainer.style.width="800px";
pdfContainer.style.padding="20px";
pdfContainer.style.background="#fff";
pdfContainer.style.fontFamily="Arial, Helvetica, sans-serif";
pdfContainer.style.textAlign="center";


pdfContainer.innerHTML=`

<div style="
display:flex;
align-items:center;
justify-content:center;
gap:12px;
border-bottom:2px solid #444;
padding-bottom:8px;
margin-bottom:10px;
">

<img src="${logoImg.src}" 
style="width:55px;height:55px;object-fit:contain;" />


<div style="text-align:left;line-height:1.4;">

<div style="
font-size:17px;
font-weight:bold;
color:#0D47A1;
">
Salvation In Christ School System
</div>

<div style="font-size:11px;">
Location: Zazay Community, Paynesville City, Monrovia
</div>

<div style="font-size:11px;">
Contact: +231 777 272 609 / 0886 320 624
</div>

<div style="font-size:11px;">
Email: salvationinchrisministries@gmail.com
</div>


</div>
</div>


<div style="
margin:12px auto;
font-size:12px;
">

<b>Grade:</b> ${gradeClassName}
&nbsp;&nbsp;

<b>Subject:</b> ${subjectName}
&nbsp;&nbsp;

<b>Period:</b> ${periodName}

</div>

`;



let tableHtml=`

<table style="
width:100%;
border-collapse:collapse;
">

<thead>

<tr style="background:#eaeff6;">

<th style="border:1px solid #777;padding:6px;">#</th>
<th style="border:1px solid #777;padding:6px;">Student</th>
<th style="border:1px solid #777;padding:6px;">Quiz</th>
<th style="border:1px solid #777;padding:6px;">Assign</th>
<th style="border:1px solid #777;padding:6px;">Partic.</th>
<th style="border:1px solid #777;padding:6px;">Test</th>
<th style="border:1px solid #777;padding:6px;">Scale</th>
<th style="border:1px solid #777;padding:6px;">Final</th>

</tr>

</thead>

<tbody>

`;



pageStudents.forEach((student,i)=>{

const r=student.subject;

const final=Number(r.final_score ?? r.test_score ?? 0);

const color=final<70 ? "#d32f2f":"#1976d2";


tableHtml+=`

<tr>

<td style="border:1px solid #777;padding:6px;">
${page*rowsPerPagePdf+i+1}
</td>


<td style="border:1px solid #777;padding:6px;">
${student.student_name}
</td>


<td style="border:1px solid #777;padding:6px;">
${r.quiz_score ?? ""}
</td>


<td style="border:1px solid #777;padding:6px;">
${r.assignment_score ?? ""}
</td>


<td style="border:1px solid #777;padding:6px;">
${r.participation_score ?? ""}
</td>


<td style="border:1px solid #777;padding:6px;">
${r.test_score ?? ""}
</td>


<td style="border:1px solid #777;padding:6px;">
${r.scale_grade ?? ""}
</td>


<td style="
border:1px solid #777;
padding:6px;
font-weight:bold;
color:${color};
">

${final}

</td>


</tr>

`;

});


tableHtml+="</tbody></table>";


pdfContainer.innerHTML+=tableHtml;


document.body.appendChild(pdfContainer);


await new Promise(resolve=>setTimeout(resolve,100));


const canvas=await html2canvas(pdfContainer,{
scale:2,
useCORS:true,
allowTaint:true
});


const imgData=canvas.toDataURL("image/png");


const imgHeight=(canvas.height*pdfWidth)/canvas.width;


pdf.addImage(
imgData,
"PNG",
0,
0,
pdfWidth,
imgHeight
);


pdf.setFontSize(10);

pdf.text(
`Page ${page+1}`,
pdfWidth/2,
pdfHeight-8,
{align:"center"}
);


document.body.removeChild(pdfContainer);


if(page<totalPages-1)
pdf.addPage();


}



pdf.save(
`${gradeClassName}_${subjectName}_${periodName}.pdf`
);


setAlertMessage("PDF generated successfully");
setAlertSeverity("success");
setSnackbarOpen(true);


};

return (
<button
id="grades-pdf-download"
style={{display:"none"}}
onClick={handleDownloadPdf}
/>
);

};


export default GradesDistributionPdf;